var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgRefreshDocument = function SvgRefreshDocument(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#F9EEDB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8337 8.8335H12.5003C11.4874 8.8335 10.6762 9.65391 10.6762 10.6668L10.667 25.3335C10.667 26.3464 11.4782 27.1668 12.4912 27.1668H23.5003C24.5132 27.1668 25.3337 26.3464 25.3337 25.3335V14.3335L19.8337 8.8335ZM21.667 23.5002H14.3337V21.6668H21.667V23.5002ZM21.667 19.8335H14.3337V18.0002H21.667V19.8335ZM18.917 15.2502V10.2085L23.9587 15.2502H18.917Z",
    fill: "#BE1D3D"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRefreshDocument);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/RefreshDocument.84c4f6c206f893f075780d702dc159ef.svg";